import { presentationObject } from './sensor-presentation';

export const warningStatuses = new Set(['ALARM', 'CRITICAL', 'WARNING', 'CAUTION']);

export function warningDisplayKey(sensor: Record<string, unknown>) {
  const key = presentationObject(sensor.warning_presentation_key);
  const presentation = presentationObject(presentationObject(sensor.attributes).warning_presentation);
  return `${key.last_received_at ?? presentation.received_at ?? sensor.last_received_at ?? ''}:${key.display_status ?? sensor.display_status ?? ''}`;
}

export function alarmDisplayKey(alarm: Record<string, unknown>) {
  return `${alarm.id}:${alarm.version}`;
}

/** 알람 ID가 같아도 다음 경고 표시 세대는 이전 해제와 구분합니다. */
export function alarmPresentationKey(alarm: Record<string, unknown>) {
  const id = String(alarm.id ?? alarm.runtime_key ?? '').replace(/^alarm:/, '');
  const received = typeof alarm.last_presented_received_at === 'string' ? alarm.last_presented_received_at : '';
  const time = Date.parse(received);
  const presented = Number.isFinite(time) ? new Date(time).toISOString() : received;
  return `alarm:${id}${presented ? `:${presented}` : ''}`;
}

/** 제품 전체 해제는 현재 화면에서 확인한 대상과 버전만 전달합니다. */
export function productWarningTargets(product: Record<string, unknown>) {
  const alarms = Array.isArray(product.alarms)
    ? product.alarms.map(presentationObject).filter(alarm => alarm.severity !== 'INFO' && alarm.status === 'OPEN' && !alarm.acknowledged_at)
    : [];
  const sensors = Array.isArray(product.sensors) ? product.sensors.map(presentationObject).filter(sensor => warningStatuses.has(String(sensor.display_status))) : [];
  const targets = (items: Record<string, unknown>[]) =>
    items
      .filter(item => typeof item.id === 'string' && typeof item.version === 'number' && Number.isInteger(item.version) && item.version >= 0)
      .map(item => ({ id: item.id as string, version: item.version as number }));
  return { scope: 'PRODUCT' as const, alarm_targets: targets(alarms), sensor_targets: targets(sensors) };
}
